import React, { Component, PropTypes } from 'react'
import styles from './Review.css'
import RewardList from '../RewardList'
import {formatDecimal, rupiah} from 'utils/formatter'
import _sortBy from 'lodash/sortBy'

class ReviewInfo extends Component {
  render () {
    const { pointFromSpendingAmount, rewards, spendingAmount, newMemberPoint, sentValidationCode } = this.props
    let formattedNewMemberPoint = newMemberPoint !== '' ? formatDecimal(newMemberPoint) : 0
    let formattedPointFromSpendingAmount = pointFromSpendingAmount !== '' ? formatDecimal(pointFromSpendingAmount) : 0

    let variationCodeContentInfo = 'Use SMS validation code for every reward redemption'
    if (!sentValidationCode) {
      variationCodeContentInfo = 'Do not use SMS validation code for reward redemptions'
    }

    let sortedRewards = _sortBy(rewards, ['point'])
    return (
      <div>
        <div className={`text-center ${styles['title']}`}>Review Your Loyalty Program</div>
        <div className='row'>
          <div style={{paddingRight: '38px'}} className='col-md-6'>
            <div className='row'>
              <div className='col-md-12'>
                <div className={styles['section-label']}>LOYALTY PROGRAM</div>
                <div className={styles['program-info']}>
                  Loyalty Program : <span className={styles['program-info-chosen']}> Rp X = Y Point </span>
                </div>
                <div className={styles['program-info']}>
                  Point Rule : <span className={styles['program-info-chosen']}>
                    For every {rupiah(spendingAmount)} member will get {formattedPointFromSpendingAmount} points
                  </span>
                </div>
                <div className={styles['program-info']}>
                  New Member Point : <span className={styles['program-info-chosen']}> {formattedNewMemberPoint} Points </span>
                </div>
              </div>
            </div>
            <div className='row top20'>
              <div style={{paddingRight: '38px'}} className='col-md-12'>
                <div className={styles['section-label']}>DURATION</div>
                <div className={styles['program-info']}>
                  <span className={styles['program-info-chosen']}>No expiry date, until deactivated manually.</span>
                </div>
              </div>
            </div>
            <div className='row top20'>
              <div style={{paddingRight: '38px'}} className='col-md-12'>
                <div className={styles['section-label']}>Validation Code for Redeem</div>
                <div className={styles['program-info']}>
                  <span className={styles['program-info-chosen']}>{variationCodeContentInfo}</span>
                </div>
              </div>
            </div>
          </div>
          <div style={{paddingLeft: '38px'}} className='col-md-6'>
            <div className={styles['section-label']}>REWARD LIST</div>
            <RewardList rewards={sortedRewards} />
          </div>
        </div>
      </div>
    )
  }
}

ReviewInfo.propTypes = {
  pointFromSpendingAmount: PropTypes.array.isRequired,
  rewards: PropTypes.array,
  spendingAmount: PropTypes.number,
  newMemberPoint: PropTypes.number
}

export default ReviewInfo



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Review/ReviewInfo.js